(function () {
  var ACCENT = '#cc0000';
  var FONT = 'font-family:Arial,Helvetica,sans-serif;font-size:12pt;color:#000000;';

  function clean(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function resolveCardImage(img, origin) {
    if (!img) return '';

    var candidate = img.currentSrc || img.getAttribute('src') || '';

    if (!candidate) {
      var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      var parsed = srcset.split(',').map(function (entry) {
        return entry.trim().split(/\s+/);
      }).filter(function (parts) {
        return parts[0];
      }).map(function (parts) {
        return { url: parts[0], width: parseInt(parts[1], 10) || 0 };
      });

      var pick = parsed.filter(function (c) { return c.width >= 320; })[0] || parsed[parsed.length - 1];
      candidate = (pick && pick.url) || '';
    }

    if (!candidate) return '';

    try {
      return new URL(candidate, origin).href;
    } catch (e) {
      return '';
    }
  }

  function collect(scope, selector) {
    var origin = window.location.protocol + '//' + window.location.hostname;
    var root = scope || document;
    var nodes = root.querySelectorAll(selector || '[data-wishlist-added]');
    var items = [];

    Array.prototype.forEach.call(nodes, function (item) {
      var titleEl = item.querySelector('[data-product-title]') || item.querySelector('.card-title');
      var linkEl = item.querySelector('[data-product-url]') || item.querySelector('a.card-title') || item.querySelector('a.card-link');

      var title = (titleEl && titleEl.dataset && titleEl.dataset.productTitle) || clean(titleEl);
      var path = (linkEl && linkEl.dataset && linkEl.dataset.productUrl) || (linkEl && linkEl.getAttribute('href'));
      if (!title || !path) return;

      var url;
      try {
        url = new URL(path, origin).href;
      } catch (e) {
        return;
      }

      var priceRoot = item.querySelector('.price');
      var onSale = !!(priceRoot && priceRoot.classList.contains('price--on-sale'));
      var lastEl = onSale
        ? item.querySelector('.price__sale .price__last .price-item')
        : item.querySelector('.price__regular .price__last .price-item');

      var isFrom = !!(lastEl && lastEl.querySelector('.text'));
      var amount = clean(lastEl).replace(/^ab\s*/i, '');
      var compare = onSale ? clean(item.querySelector('.price__sale .price__compare .price-item')) : '';

      var img = item.querySelector('.card-media img') || item.querySelector('img');

      items.push({
        title: title,
        url: url,
        amount: amount,
        compare: compare,
        isFrom: isFrom,
        imageSrc: resolveCardImage(img, origin)
      });
    });

    return items;
  }

  function buildHtml(items) {
    var rows = items.map(function (item) {
      var priceLine;
      if (item.compare) {
        priceLine = 'Preis <s>' + escapeHtml(item.compare) + '</s> nur '
          + (item.isFrom ? 'ab ' : '')
          + '<b style="color:' + ACCENT + ';">' + escapeHtml(item.amount) + '</b>';
      } else {
        priceLine = 'Preis: ' + (item.isFrom ? 'ab ' : '')
          + '<b style="color:' + ACCENT + ';">' + escapeHtml(item.amount) + '</b>';
      }

      var imageCell = item.imageSrc
        ? '<img src="' + escapeHtml(item.imageSrc) + '" width="80" alt="" style="display:block;width:80px;height:auto;border:0;border-radius:8px;">'
        : '&nbsp;';

      return '<table cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;margin:0 0 18px 0;">'
        + '<tr>'
        + '<td valign="top" style="padding-right:14px;width:94px;">' + imageCell + '</td>'
        + '<td valign="top" style="' + FONT + 'line-height:1.45;">'
        + '<div style="font-weight:bold;">' + escapeHtml(item.title) + '</div>'
        + '<div>' + priceLine + '</div>'
        + '<div>Link: <a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.url) + '</a></div>'
        + '</td>'
        + '</tr>'
        + '</table>';
    }).join('');

    return '<div style="' + FONT + '">' + rows + '</div>';
  }

  function buildText(items) {
    return items.map(function (item) {
      var priceLine = item.compare
        ? 'Preis ' + item.compare + ' nur ' + (item.isFrom ? 'ab ' : '') + item.amount
        : 'Preis: ' + (item.isFrom ? 'ab ' : '') + item.amount;

      return item.title + '\n' + priceLine + '\nLink: ' + item.url;
    }).join('\n\n');
  }

  function attach(link, options) {
    if (!link) return;

    var opts = options || {};
    var items = collect(opts.scope, opts.selector);

    link.wishlistSharePayload = {
      html: buildHtml(items),
      text: buildText(items)
    };

    link.href = 'mailto:?subject=' + encodeURIComponent(opts.subject || '')
      + '&body=' + encodeURIComponent(link.wishlistSharePayload.text);

    if (link.dataset.shareBound) return;
    link.dataset.shareBound = 'true';

    link.addEventListener('click', function (event) {
      var payload = link.wishlistSharePayload;
      if (!payload || !payload.html || !navigator.clipboard || !window.ClipboardItem) return;

      event.preventDefault();

      var href = link.getAttribute('href');
      var openMailClient = function () { window.location.href = href; };

      navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([payload.html], { type: 'text/html' }),
          'text/plain': new Blob([payload.text], { type: 'text/plain' })
        })
      ]).then(function () {
        if (typeof opts.onCopied === 'function') opts.onCopied();
        openMailClient();
      }).catch(openMailClient);
    });
  }

  window.WishlistShare = {
    collect: collect,
    buildHtml: buildHtml,
    buildText: buildText,
    attach: attach
  };
})();
